import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const MainHeader = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);

  const userName = localStorage.getItem('user') || 'User';
  const firstLetter = userName.charAt(0).toUpperCase();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user_id');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div className="flex justify-between items-center bg-white py-2 px-3 md:py-3 md:px-6 shadow-sm">
      <div className="flex items-center">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="p-2 text-gray-600 rounded-md md:hidden"
          aria-label="Toggle sidebar"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
      <div className="relative mr-2 md:mr-5" ref={profileMenuRef}>
        <div
          className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center cursor-pointer md:w-10 md:h-10"
          onClick={() => setShowProfileMenu((prev) => !prev)}
        >
      <span className="text-lg font-bold font-[Archivo] text-white mt-[3px] md:mt-0 md:text-xl">
        {firstLetter}
      </span>
        </div>
        {showProfileMenu && (
          <div className="absolute right-0 top-12 w-32 md:w-40 bg-white border border-gray-200 rounded-md shadow-lg z-50">
            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 md:text-base"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainHeader;